import { z } from 'zod'

export function getCurrentStepSchema(fieldKey: string) {
	return z.object({
		[fieldKey]: z
			.string()
			.optional()
			.refine(
				value => value !== undefined && value !== '',
				`${fieldKey} Fill in the form to continue`,
			),
	})
}
